import mutations from "./mutations";
import actions from "./actions";

const state = {
  talentPools: [],
  currentTalentPool: null,
  isFetchingCurrentTalentPool: false,
  isFetchingTalentPools: false
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
